import { SmopUserTypeCode } from "@saleor/types/globalTypes";
import { getStaffUserType } from "@saleor/utils/smop";
export const useAssignInfo = userData => {
  const accountUserType = getStaffUserType(userData);

  const brandInfoResult = () => {
    if (accountUserType?.code === SmopUserTypeCode.SELLER_MASTER) {
      const brand = accountUserType?.accesses.find(
        a => a.accessType === "BRAND"
      );
      if (brand) {
        return brand.objectId;
      }
    }

    return " ";
  };
  const tenantInfoResult = () => {
    if (accountUserType?.code === SmopUserTypeCode.STORE_ADMIN) {
      const tenant = accountUserType?.accesses.find(
        a => a.accessType === "TENANT"
      );
      if (tenant) {
        return tenant.objectId;
      }
    }
    return " ";
  };
  const mallInfoResult = () => {
    if (
      accountUserType?.code === SmopUserTypeCode.MALL_ADMIN ||
      accountUserType?.code === SmopUserTypeCode.OMI_OPS ||
      accountUserType?.code === SmopUserTypeCode.RIDER ||
      accountUserType?.code === SmopUserTypeCode.RUNNER
    ) {
      const mall = accountUserType?.accesses.find(a => a.accessType === "MALL");
      if (mall) {
        return mall.objectId;
      }
    }
    return " ";
  };

  return {
    brand: brandInfoResult(),
    mall: mallInfoResult(),
    tenant: tenantInfoResult(),
    userType: accountUserType
  };
};
